// utils/userRoleUtils.js

import { getUserData } from "./localStorage";

const ROLE = {
    SUPER_ADMIN: 1,
    SUPERVISOR: 2,
    ADMIN: 3,
    All_FINANCES: [6, 24],
    FINANCE: 6,
    MAIN_FINANCE: 24,
    MANAGEMENT: 4
};

export const getUserRoleFlags = () => {
    const userData = getUserData();
    const roleId = userData?.RoleId;
    return {

        isSuperAdmin: roleId === ROLE.SUPER_ADMIN,
        isAdmin: roleId === ROLE.ADMIN,

        isSupervisor: roleId === ROLE.SUPERVISOR,

        isAllFinance: ROLE.All_FINANCES.includes(roleId),
        isFinance: ROLE.FINANCE,
        isMainFinance: ROLE.MAIN_FINANCE,

        isManagement: roleId === ROLE.MANAGEMENT,
    };
};